<template>
  <form class="netpeak-form" novalidate="novalidate" @submit.prevent>
    <div class="netpeak-form-row">
      <input
        type="email"
        class="netpeak-form-input"
        required
        name="email"
        v-model="email"
        @input="onEmailChange"
        :placeholder="$t('netpeakForm.field')"
      />
      <button class="netpeak-form-button" @click="onSubmit">
        {{ buttonText }}
      </button>
    </div>
    <div class="netpeak-form-error" v-if="errors.email">
      {{ errors.email }}
    </div>
    <div class="netpeak-form-row">
      <label class="netpeak-form-checkbox" @click="handleTerms">
        <input type="checkbox" name="terms" :checked="terms" />
        <span>{{ $t('netpeakForm.checkbox') }}</span>
      </label>
    </div>
    <div class="netpeak-form-error" v-if="errors.terms">
      {{ errors.terms }}
    </div>
  </form>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
import { required, sameAs, helpers } from 'vuelidate/lib/validators'
import axios from 'axios'

export default {
  name: 'NetpeakForm',
  props: {
    type: {
      type: String,
      required: false,
      default: '',
    },
    buttonText: {
      type: String,
      required: false,
      default() {
        return this.$t('netpeakForm.button')
      },
    },
  },
  data() {
    return {
      terms: false,
      email: '',
      errors: {
        terms: '',
        email: '',
      },
    }
  },
  computed: {
    ...mapState(['netpeakModal']),
  },
  watch: {
    netpeakModal(newVal) {
      if (!newVal && this.type === 'modal') {
        this.terms = false
        this.email = ''
        this.errors.terms = ''
        this.errors.email = ''
      }
    },
  },
  validations: {
    email: {
      required,
      alpha: helpers.regex(
        'alpha',
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      ),
    },
    terms: {
      sameAs: sameAs(() => true),
    },
  },
  methods: {
    ...mapMutations(['setSubscriptionSent']),
    handleTerms(e) {
      if (this.type === 'footer' && e.target.nodeName === 'SPAN') {
        return
      }
      this.terms = !this.terms
      this.errors.terms = ''
    },
    onEmailChange() {
      if (this.errors.email) {
        this.errors.email = ''
      }
    },
    onSubmit() {
      if (!this.email) {
        this.errors.email = this.$t('netpeakForm.emptyMail')
      } else if (this.$v.email.$invalid) {
        this.errors.email = this.$t('netpeakForm.invalidMail')
      }

      if (!this.terms) {
        this.errors.terms = this.$t('netpeakForm.emptyTerms')
      }

      if (!this.$v.$invalid) {
        const headers = {
          Accept: 'application/json; charset=UTF-8',
          'Content-Type': 'application/json',
          Authorization: `Basic ${window.btoa(
            `apptown:${process.env.VUE_APP_RETENO_API_KEY}`
          )}`,
        }
        const body = {
          formType: this.type === 'footer' ? 1 : undefined,
          contact: {
            channels: [
              {
                type: 'email',
                value: this.email,
              },
            ],
          },
        }
        this.$gtag.event('subscription')
        axios
          .post('https://api.reteno.com/api/v1/contact/subscribe', body, {
            headers,
          })
          .then((res) => {
            const { data } = res
            if (data && typeof data.isNew === 'boolean' && !data.isNew) {
              this.errors.email = this.$t('netpeakForm.mailExists')
            } else {
              this.setSubscriptionSent(true)
            }
          })
          .catch((e) => {
            this.errors.email = this.$t('netpeakForm.requestError')
            console.log('**NetpeakForm** subscribe', e)
          })
      }
    },
  },
}
</script>

<style>
.netpeak-form-row {
  flex-grow: 1;
  display: flex;
  margin-bottom: 10px;
}

@media only screen and (max-width: 600px) {
  .netpeak-form-row {
    flex-direction: column;
  }
  .netpeak-form-row .netpeak-form-button {
    margin-left: 0;
    margin-top: 15px;
  }
}

.netpeak-form-error {
  color: red;
  font-size: 12px;
  margin-bottom: 10px;
}
.netpeak-form-checkbox {
  font-weight: normal;
  font-size: 16px;
  cursor: pointer;
  position: relative;
}
.netpeak-form-checkbox input[type='checkbox'] {
  position: absolute;
  left: 0;
  top: 50%;
  transform: translate(0, -50%);
  margin: 0;
  z-index: 1;
}
.netpeak-form-checkbox span {
  position: relative;
  z-index: 2;
  padding-left: 25px;
  display: block;
}
.netpeak-form-input {
  flex-grow: 1;
  border: 2px solid #f87547 !important;
  padding-left: 20px !important;
}
.netpeak-form-button {
  margin-left: 15px;
  flex-grow: 1;
  background: #f87547 !important;
  border-radius: 30px;
  color: #fff;
  font-weight: 700;
  padding: 0 40px;
}
.netpeak-form-button:hover {
  background: #f39d7e !important;
}
</style>
